import api from 'api';

export const loadAffectedLevel = api(
  'GET /api/smart-rules/fields/affected-levels'
);

export const loadSecondaryAffectedLevel = api(
  'GET /api/smart-rules/fields/secondary-affected-levels'
);

export const loadNetworks = api('GET /api/smart-rules/fields/networks');

export const loadPlatforms = api('GET /api/smart-rules/fields/platforms');

export const loadApplications = api('GET /api/smart-rules/fields/applications');

export const loadAffiliates = api('GET /api/smart-rules/fields/affiliates');

export const loadOwners = api('GET /api/smart-rules/fields/owners');

export const loadLabels = api('GET /api/smart-rules/fields/labels');

export const loadCampaigns = api('GET /api/smart-rules/fields/campaigns');

export const loadPartnerCampaigns = api(
  'GET /api/smart-rules/fields/partner-campaigns'
);

export const loadAdSets = api('GET /api/smart-rules/fields/ad-sets');

export const loadCountries = api('GET /api/smart-rules/fields/countries');

export const loadTrafficTypes = api(
  'GET /api/smart-rules/fields/traffic-types'
);

export const loadMetrics = api('GET /api/smart-rules/fields/metrics');

export const loadFormulaMetrics = api(
  'GET /api/smart-rules/fields/formula-metrics'
);

export const loadOperators = api('GET /api/smart-rules/fields/operators');

//rewrite to buttonGroup with fixed types (currently unused but maybe needed in future)
export const loadCalculationTypes = api(
  'GET /api/smart-rules/fields/calculation-types'
);

export const loadCreativeStatus = api(
  'GET /api/smart-rules/fields/creative-status'
);

export const loadPeriods = api('GET /api/smart-rules/fields/periods');
export const loadPeriodTypes = api('GET /api/smart-rules/fields/period-types');

export const loadExtraMetrics = api(
  'GET /api/smart-rules/fields/extra-metrics'
);

export const loadPayTo = api('GET /api/smart-rules/fields/pay-to');

export const loadComparePeriods = api(
  'GET /api/smart-rules/fields/compare-periods'
);

export const loadModifyActions = api(
  'GET /api/smart-rules/fields/modify-actions'
);

export const loadModifyActionOperators = api(
  'GET /api/smart-rules/fields/modify-action/operators'
);

export const loadUsers = api('GET /api/smart-rules/fields/users');

export const loadPopulationDiffs = api(
  'POST /api/smart-rules/fields/population-diffs'
);

export const loadConceptCreationPeriods = api(
  'GET /api/smart-rules/fields/concept-creation-periods'
);
export const loadCreativeCreationPeriods = api(
  'GET /api/smart-rules/fields/creative-creation-periods'
);
export const loadCreativeTypes = api(
  'POST /api/smart-rules/fields/creative-types'
);
export const loadLanguages = api('GET /api/smart-rules/fields/languages');
export const loadMediaTypes = api('POST /api/smart-rules/fields/media-types');
export const loadOrientations = api(
  'POST /api/smart-rules/fields/orientations'
);
export const loadTags = api('GET /api/smart-rules/fields/tags');
export const loadStatuses = api('GET /api/smart-rules/fields/statuses');

export const loadChannels = api('POST /api/smart-rules/fields/channels');

export const loadMasterCampaigns = api(
  'POST /api/smart-rules/fields/master-campaigns'
);
export const loadSocialMediaPlatforms = api(
  'POST /api/smart-rules/fields/social-media-platforms'
);
export const loadInfluencerCampaigns = api(
  'POST /api/smart-rules/fields/influencer-campaigns'
);
